/**
 * Enum dos tipos de dimensões disponíveis no TagBook.
 *
 * @example
 * import { getDimensionByUnit } from 'src/utils'
 *
 * // Utilize ela com a função getDimensionByUnit para obter o valor respectivo.
 * getBusinessUnit(Dimension.RESELLER_SLUG, 'BOT')
 */
export enum Dimension {
  /**
   * @description Dimension para identificar o Id do revendedor
   * @index dimension2
   * @values `string`
   */
  RESELLER_SLUG = 'RESELLER_SLUG',
  /**
   * @description Dimension para verificar se o produto esta com o valor 'regular' ou em 'promoção'
   * @index dimension6
   * @values `regular`, `promo`
   */
  PROMO_STATUS = 'PROMO_STATUS',
  /**
   * @description Dimension de identificação do tipo de usuário que está acessando a página
   *
   * Exemplo: Caso já tenha efetuado login, o tipo do usuário é `revendedor`
   * @index dimension9
   * @values `cliente`, `revendedor`
   */
  USER_TYPE = 'USER_TYPE',
  /**
   * @description Dimension de identificação se o produto é pronta entrega
   * @index dimension12
   * @values `pronta-entrega`, `nao-pronta-entrega`
   */
  PROMPT_DELIVERY = 'PROMPT_DELIVERY',
  /**
   * @description Dimension para passar o preço dos produtos da revendedora
   * @index dimension18
   * @values `number`
   */
  RESELLER_PRICE = 'RESELLER_PRICE',
  /**
   * @description Dimension de identificação do ID do cliente final reconhecido.
   *
   * Em Eudora, esta dimension possui uma dimension com campo diferente (dimension20).
   * @index dimension22
   * @values `string`
   */
  CF_ID = 'CF_ID',
  /**
   * @description Dimension para identificar o ID da cobrança
   *
   * Em Eudora, esta dimension é diferente (dimension19).
   * @index dimension21
   * @values `string`
   */
  TRANSACTION_ID = 'TRANSACTION_ID',
}
